// extracted by mini-css-extract-plugin
export default {"opponents":"opponents-QbhqOA2R","wrap":"wrap-X1V5zUfo"};